import React, { useState } from "react";
import DashboardMetrics from "./analytics/DashboardMetrics";
import UserLevelTracking from "./analytics/UserLevelTracking";
import SoundChartTracking from "./analytics/SoundChartTracking";
import Engagements from "../engagements/Engagements";
import PageHeader from "../../components/ui/PageHeader";
import { HOME_CRUMB } from "../../components/ui/Breadcrumbs";
import SegmentedTabs from "../../components/ui/SegmentedTabs";

type AdminAnalyticsTab = "metrics" | "tracking" | "thirdPartyApis" | "engagement";

const TABS: { key: AdminAnalyticsTab; label: string }[] = [
  { key: "metrics", label: "Dashboard Metrics" },
  { key: "tracking", label: "User-Level Tracking" },
  { key: "thirdPartyApis", label: "Third-Party APIs" },
  { key: "engagement", label: "App Update Engagement" },
];

const AdminAnalytics: React.FC = () => {
  const [activeTab, setActiveTab] = useState<AdminAnalyticsTab>("metrics");

  return (
    <div className="py-2 sm:p-6">
      <PageHeader
        breadcrumbs={[HOME_CRUMB, { label: "Admin Analytics" }]}
        className="mb-6"
        title="Admin Analytics"
        description="Platform usage, user activity, and third-party API health."
      />

      <SegmentedTabs
        className="mb-6 overflow-x-auto scrollbar-hide"
        items={TABS}
        value={activeTab}
        onChange={(key) => setActiveTab(key as AdminAnalyticsTab)}
        ariaLabel="Admin analytics sections"
      />

      {/* Tab Content */}
      {activeTab === "metrics" && <DashboardMetrics />}
      {activeTab === "tracking" && <UserLevelTracking />}
      {activeTab === "thirdPartyApis" && <SoundChartTracking />}
      {activeTab === "engagement" && <Engagements />}
    </div>
  );
};

export default AdminAnalytics;
